import React from "react";
import "./OverlayComponent.scss";

class OverlayComponent extends React.Component {
    render() {
        return <div className="overlay">{this.props.children}</div>;
    }
}
export default OverlayComponent;
